import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useService } from '../../../services/services';
import Classifier from '../../../interfaces/classifier';
import List from '../../../components/common/list';
import Title from '../../../components/common/title';
import ClassifierGroup from '../../../interfaces/classifierGroup';
import { INTERNAL_CLASSIFIER_VALUES } from '../../../router/routes';
import { route } from '../../../services/utils';

export default function Classifiers() {
  const { groupKey } = useParams<{ groupKey: string }>();
  const { internalClassifierService } = useService();
  const [data, setData] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const subscription = internalClassifierService
      .index(groupKey)
      .subscribe((classifierGroup: ClassifierGroup) => {
        const classifierElements = classifierGroup.classifiers.map(
          (classifier: Classifier) => {
            return {
              id: classifier.id,
              value: classifier.name,
              transferUrl: route(INTERNAL_CLASSIFIER_VALUES, {
                classifierId: classifier.id,
                groupKey: groupKey,
              }),
            };
          }
        );
        setData(classifierElements);
        setTitle(classifierGroup.name);
      });

    return () => subscription.unsubscribe();
  }, [groupKey, internalClassifierService, setData]);

  return (
    <>
      <Title title={title} />
      <List data={data} />
    </>
  );
}
